import { useState } from "react";
import SandwichRuleLogTable from "./SandwichRuleLogTable";
import ExecuteSandwichRule from "./SandwichRuleComponents";

const SandwichRuleManagements = () => {

    const [toggleState, setToggleState] = useState(1);

    const getSelectedTitle = () => {
        switch (toggleState) {
            case 1:
                return 'Execute Sandwich Rule';
            case 2:
                return 'Execute Sandwich Rule Log';
            default:
                return 'Execute Sandwich Rule';
        }
    };
    return (
        <>

            <div className="bloc-tabss  wfm-margin" style={{ marginLeft: '10px' }}>
                <button
                    className={toggleState === 1 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss"}
                    onClick={() => setToggleState(1)}
                >
                    Execute Sandwich Rule
                </button>
                <button
                    className={toggleState === 2 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss"}
                    onClick={() => setToggleState(2)}
                >
                    Sandwich Rule Log
                </button>

            </div>

            <div className="content-tabs" style={{ margin: '10px' }}>

                {toggleState === 1 ? <ExecuteSandwichRule /> : null}

                {toggleState === 2 ? <SandwichRuleLogTable /> : null}

            </div>


        </>
    )
}

export default SandwichRuleManagements
